"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.testColumns = exports.emptyComponent = exports.testData = void 0;
const React = __importStar(require("react"));
const moment_timezone_1 = __importDefault(require("moment-timezone"));
moment_timezone_1.default.tz.setDefault("CST");
function toLocalDate(value) {
    if (!value) {
        return "";
    }
    value = value.substring(0, 10);
    const date = moment_timezone_1.default.tz(value, "America/Chicago");
    return date.toDate();
}
//spellcheck-off
exports.testData = [
    {
        OrderNumber: "31135",
        OrderDate: toLocalDate("2018-12-06T00:00:00Z"),
        OrderStatusId: 12,
        TechOrderStatus: "INCOMPLETE",
        JobNumber: null,
        OrderedBy: null,
        WaitingForId: null,
        OrderTypeId: null,
        ReasonId: null,
        PriorityId: null,
        TotalPrice: null,
        TotalCost: null,
        SiteAddress1: "110 S. Poplar St.",
        SiteAddress2: "",
        SiteAddress3: null,
        SiteCity: "Wilmington",
        SiteRegion: "WI",
        SitePostalCode: "52353",
        ShipViaId: 1,
        RegionId: 1,
        DivisionId: null,
        Customer: {
            CustomerName: "Clyburn Street Properties",
            CustomerNumber: "000000012045",
            OpenOrderAmount: 109936.12,
            Id: 16
        },
        AssignedTo: {
            FirstName: "Daniel",
            LastName: "Greuel",
            UserId: 40743,
            Id: 1821
        },
        Site: {
            SiteNumber: "000000000000003",
            Id: 5
        },
        RelatedCall: {},
        CustomerId: 16,
        AssignedToId: 40743,
        SiteId: 5,
        RelatedCallId: null,
        Id: 33501
    },
    {
        OrderNumber: "31122",
        OrderDate: toLocalDate("2019-02-19T00:00:00Z"),
        OrderStatusId: 12,
        TechOrderStatus: "INCOMPLETE",
        JobNumber: null,
        OrderedBy: null,
        WaitingForId: null,
        ReasonId: null,
        PriorityId: null,
        TotalPrice: null,
        TotalCost: null,
        SiteAddress1: "413 Old Billerica Road",
        SiteAddress2: "",
        SiteAddress3: null,
        SiteCity: "Bedford",
        SiteRegion: "MA",
        SitePostalCode: "02114",
        ShipViaId: 1,
        RegionId: 1,
        DivisionId: null,
        Customer: {
            CustomerName: "GAP Incorporated",
            CustomerNumber: "000000012035",
            OpenOrderAmount: 1281.6,
            Id: 14
        },
        AssignedTo: {
            FirstName: "Daniel",
            LastName: "Greuel",
            UserId: 40743,
            Id: 1821
        },
        Site: {
            SiteNumber: "000000000000002",
            Id: 8
        },
        RelatedCall: {},
        CustomerId: 14,
        AssignedToId: 40743,
        SiteId: 8,
        RelatedCallId: null,
        Id: 33488,
        OrderTypeId: null
    },
    {
        OrderNumber: "31130",
        OrderDate: toLocalDate("2018-12-05T00:00:00Z"),
        OrderStatusId: 12,
        TechOrderStatus: "CLOSED",
        JobNumber: null,
        OrderedBy: null,
        WaitingForId: null,
        ReasonId: null,
        PriorityId: null,
        TotalPrice: null,
        TotalCost: null,
        SiteAddress1: "123 Lane ",
        SiteAddress2: null,
        SiteAddress3: null,
        SiteCity: "Snackville",
        SiteRegion: "Treatscosin",
        SitePostalCode: "987",
        ShipViaId: 1,
        RegionId: 1,
        DivisionId: null,
        Customer: {
            CustomerName: "GAP Incorporated",
            CustomerNumber: "000000012035",
            OpenOrderAmount: 1281.6,
            Id: 14
        },
        AssignedTo: {
            FirstName: "Daniel",
            LastName: "Greuel",
            UserId: 40743,
            Id: 1821
        },
        Site: {
            SiteNumber: "Billing",
            Id: 1
        },
        RelatedCall: {},
        CustomerId: 14,
        AssignedToId: 40743,
        SiteId: 1,
        RelatedCallId: null,
        Id: 33496,
        OrderTypeId: null
    },
    {
        OrderNumber: "31125",
        OrderDate: toLocalDate("2018-12-05T00:00:00Z"),
        OrderStatusId: 12,
        TechOrderStatus: "ACCEPTED",
        JobNumber: null,
        OrderedBy: null,
        WaitingForId: null,
        ReasonId: null,
        PriorityId: null,
        TotalPrice: 145,
        TotalCost: 0,
        SiteAddress1: "123 Lane ",
        SiteAddress2: null,
        SiteAddress3: null,
        SiteCity: "Snackville",
        SiteRegion: "Treatscosin",
        SitePostalCode: "987",
        ShipViaId: 1,
        RegionId: 1,
        DivisionId: null,
        Customer: {
            CustomerName: "GAP Incorporated",
            CustomerNumber: "000000012035",
            OpenOrderAmount: 1281.6,
            Id: 14
        },
        AssignedTo: {
            FirstName: "Daniel",
            LastName: "Greuel",
            UserId: 40743,
            Id: 1821
        },
        Site: {
            SiteNumber: "Billing",
            Id: 1
        },
        RelatedCall: {},
        CustomerId: 14,
        AssignedToId: 40743,
        SiteId: 1,
        RelatedCallId: null,
        Id: 33491,
        OrderTypeId: null
    },
    {
        OrderNumber: "31089",
        OrderDate: toLocalDate("2018-11-29T00:00:00Z"),
        OrderStatusId: 12,
        TechOrderStatus: "CLOSED",
        JobNumber: null,
        OrderedBy: null,
        WaitingForId: null,
        ReasonId: null,
        PriorityId: 2,
        TotalPrice: 25,
        TotalCost: 0,
        SiteAddress1: "3415 Saemann Ave2",
        SiteAddress2: "",
        SiteAddress3: "",
        SiteCity: "Sheboygan2",
        SiteRegion: "WI",
        SitePostalCode: "53081",
        ShipViaId: 8,
        RegionId: 1,
        DivisionId: null,
        Customer: {
            CustomerName: "Tri-State Paving",
            CustomerNumber: "000000000001",
            OpenOrderAmount: 35128708.55,
            Id: 1
        },
        AssignedTo: {
            FirstName: "Daniel",
            LastName: "Greuel",
            UserId: 40743,
            Id: 1821
        },
        Site: {
            SiteNumber: "Billing",
            Id: 19
        },
        RelatedCall: {
            Id: 39051
        },
        CustomerId: 1,
        AssignedToId: 40743,
        SiteId: 19,
        RelatedCallId: 39051,
        Id: 32459,
        OrderTypeId: null
    },
    {
        OrderNumber: "31085",
        OrderDate: toLocalDate("2018-11-28T00:00:00Z"),
        OrderStatusId: 16,
        TechOrderStatus: "INCOMPLETE",
        JobNumber: null,
        OrderedBy: null,
        WaitingForId: null,
        ReasonId: null,
        PriorityId: 2,
        TotalPrice: 11,
        TotalCost: 3,
        SiteAddress1: "670 Manson St",
        SiteAddress2: "",
        SiteAddress3: null,
        SiteCity: "San Francisco",
        SiteRegion: "CA",
        SitePostalCode: "95782",
        ShipViaId: 1,
        RegionId: 1,
        DivisionId: null,
        Customer: {
            CustomerName: "21st Century enterprises",
            CustomerNumber: "000000000200",
            OpenOrderAmount: 658.9,
            Id: 35
        },
        AssignedTo: {
            FirstName: "Daniel",
            LastName: "Greuel",
            UserId: 40743,
            Id: 1821
        },
        Site: {
            SiteNumber: "Billing",
            Id: 4
        },
        RelatedCall: {
            Id: 39049
        },
        CustomerId: 35,
        AssignedToId: 40743,
        SiteId: 4,
        RelatedCallId: 39049,
        Id: 32455,
        OrderTypeId: null
    },
    {
        OrderNumber: "31083",
        OrderDate: toLocalDate("2018-11-28T00:00:00Z"),
        OrderStatusId: 12,
        TechOrderStatus: "NEW",
        JobNumber: null,
        OrderedBy: null,
        WaitingForId: null,
        ReasonId: null,
        PriorityId: 2,
        TotalPrice: null,
        TotalCost: null,
        SiteAddress1: "355009 Plymouth Road1",
        SiteAddress2: "",
        SiteAddress3: null,
        SiteCity: "Livonia",
        SiteRegion: "MI",
        SitePostalCode: "48150",
        ShipViaId: 1,
        RegionId: 1,
        DivisionId: null,
        Customer: {
            CustomerName: "Ford Motor Company",
            CustomerNumber: "000000000150",
            OpenOrderAmount: 9075.6,
            Id: 34
        },
        AssignedTo: {
            FirstName: "Daniel",
            LastName: "Greuel",
            UserId: 40743,
            Id: 1821
        },
        Site: {
            SiteNumber: "Billing",
            Id: 3
        },
        RelatedCall: {
            Id: 39047
        },
        CustomerId: 34,
        AssignedToId: 40743,
        SiteId: 3,
        RelatedCallId: 39047,
        Id: 32453,
        OrderTypeId: null
    },
    {
        OrderNumber: "31082",
        OrderDate: toLocalDate("2018-11-28T00:00:00Z"),
        OrderStatusId: 12,
        TechOrderStatus: "ON HOLD",
        JobNumber: null,
        OrderedBy: null,
        WaitingForId: null,
        ReasonId: null,
        PriorityId: 2,
        TotalPrice: 10,
        TotalCost: 2,
        SiteAddress1: "110 S. Poplar St.",
        SiteAddress2: "",
        SiteAddress3: null,
        SiteCity: "Wilmington",
        SiteRegion: "WI",
        SitePostalCode: "52353",
        ShipViaId: 1,
        RegionId: 1,
        DivisionId: null,
        Customer: {
            CustomerName: "Clyburn Street Properties",
            CustomerNumber: "000000012045",
            OpenOrderAmount: 109936.12,
            Id: 16
        },
        AssignedTo: {
            FirstName: "Daniel",
            LastName: "Greuel",
            UserId: 40743,
            Id: 1821
        },
        Site: {
            SiteNumber: "000000000000003",
            Id: 5
        },
        RelatedCall: {
            Id: 39046
        },
        CustomerId: 16,
        AssignedToId: 40743,
        SiteId: 5,
        RelatedCallId: 39046,
        Id: 32452,
        OrderTypeId: null
    },
    {
        OrderNumber: "31081",
        OrderDate: toLocalDate("2018-12-02T00:00:00Z"),
        OrderStatusId: 12,
        TechOrderStatus: "NEW",
        JobNumber: null,
        OrderedBy: null,
        WaitingForId: null,
        ReasonId: null,
        PriorityId: 2,
        TotalPrice: null,
        TotalCost: null,
        SiteAddress1: "910 Gateway Commons Circle",
        SiteAddress2: "",
        SiteAddress3: null,
        SiteCity: "Wake Forest",
        SiteRegion: "NC",
        SitePostalCode: "27587",
        ShipViaId: 1,
        RegionId: 1,
        DivisionId: null,
        Customer: {
            CustomerName: "C.B. Richard Ellis",
            CustomerNumber: "000000012011",
            OpenOrderAmount: 0,
            Id: 10
        },
        AssignedTo: {
            FirstName: "Daniel",
            LastName: "Greuel",
            UserId: 40743,
            Id: 1821
        },
        Site: {
            SiteNumber: "000000000000002",
            Id: 12
        },
        RelatedCall: {
            Id: 39045
        },
        CustomerId: 10,
        AssignedToId: 40743,
        SiteId: 12,
        RelatedCallId: 39045,
        Id: 32451,
        OrderTypeId: null
    },
    {
        OrderNumber: "31080",
        OrderDate: toLocalDate("2018-12-01T00:00:00Z"),
        OrderStatusId: 12,
        TechOrderStatus: "INCOMPLETE",
        JobNumber: null,
        OrderedBy: null,
        WaitingForId: null,
        ReasonId: null,
        PriorityId: 2,
        TotalPrice: null,
        TotalCost: null,
        SiteAddress1: "413 Old Billerica Road",
        SiteAddress2: "",
        SiteAddress3: null,
        SiteCity: "Bedford",
        SiteRegion: "MA",
        SitePostalCode: "02114",
        ShipViaId: 1,
        RegionId: 1,
        DivisionId: null,
        Customer: {
            CustomerName: "GAP Incorporated",
            CustomerNumber: "000000012035",
            OpenOrderAmount: 1281.6,
            Id: 14
        },
        AssignedTo: {
            FirstName: "Daniel",
            LastName: "Greuel",
            UserId: 40743,
            Id: 1821
        },
        Site: {
            SiteNumber: "000000000000002",
            Id: 8
        },
        RelatedCall: {
            Id: 39044
        },
        CustomerId: 14,
        AssignedToId: 40743,
        SiteId: 8,
        RelatedCallId: 39044,
        Id: 32450,
        OrderTypeId: null
    },
    {
        OrderNumber: "31124",
        OrderDate: toLocalDate("2018-12-05T00:00:00Z"),
        OrderStatusId: 12,
        TechOrderStatus: null,
        JobNumber: null,
        OrderedBy: "Fred Lindstrom",
        WaitingForId: null,
        ReasonId: null,
        PriorityId: null,
        TotalPrice: null,
        TotalCost: null,
        SiteAddress1: "6121 51st St.",
        SiteAddress2: "",
        SiteAddress3: null,
        SiteCity: "Chicago",
        SiteRegion: "IL",
        SitePostalCode: "60608",
        ShipViaId: 1,
        RegionId: 1,
        DivisionId: null,
        Customer: {
            CustomerName: "American Demolition Corp.",
            CustomerNumber: "000000003480",
            OpenOrderAmount: 72,
            Id: 25
        },
        AssignedTo: {
            FirstName: "Daniel",
            LastName: "Greuel",
            UserId: 40743,
            Id: 1821
        },
        Site: {
            SiteNumber: "000000000000001",
            Id: 65
        },
        RelatedCall: {},
        CustomerId: 25,
        AssignedToId: 40743,
        SiteId: 65,
        RelatedCallId: null,
        Id: 33490,
        OrderTypeId: null
    },
    {
        OrderNumber: "31112",
        OrderDate: toLocalDate("2018-12-04T00:00:00Z"),
        OrderStatusId: 12,
        TechOrderStatus: null,
        JobNumber: null,
        OrderedBy: null,
        WaitingForId: null,
        ReasonId: null,
        PriorityId: null,
        TotalPrice: 7,
        TotalCost: 0,
        SiteAddress1: "531 W. Touhy Ave.",
        SiteAddress2: "",
        SiteAddress3: null,
        SiteCity: "Des Plaines",
        SiteRegion: "IL",
        SitePostalCode: "60018",
        ShipViaId: 1,
        RegionId: 1,
        DivisionId: null,
        Customer: {
            CustomerName: "Tax Airfreight, Inc.",
            CustomerNumber: "000000013450",
            OpenOrderAmount: 1160.99,
            Id: 19
        },
        AssignedTo: {
            FirstName: "Daniel",
            LastName: "Greuel",
            UserId: 40743,
            Id: 1821
        },
        Site: {
            SiteNumber: "000000000000002",
            Id: 13
        },
        RelatedCall: {},
        CustomerId: 19,
        AssignedToId: 40743,
        SiteId: 13,
        RelatedCallId: null,
        Id: 33478,
        OrderTypeId: null
    },
    {
        OrderNumber: "31113",
        OrderDate: toLocalDate("2018-12-04T00:00:00Z"),
        OrderStatusId: 12,
        TechOrderStatus: null,
        JobNumber: null,
        OrderedBy: null,
        WaitingForId: null,
        ReasonId: null,
        PriorityId: null,
        TotalPrice: 10,
        TotalCost: 2,
        SiteAddress1: "531 W. Touhy Ave.",
        SiteAddress2: "",
        SiteAddress3: null,
        SiteCity: "Des Plaines",
        SiteRegion: "IL",
        SitePostalCode: "60018",
        ShipViaId: 1,
        RegionId: 1,
        DivisionId: null,
        Customer: {
            CustomerName: "Tax Airfreight, Inc.",
            CustomerNumber: "000000013450",
            OpenOrderAmount: 1160.99,
            Id: 19
        },
        AssignedTo: {
            FirstName: "Daniel",
            LastName: "Greuel",
            UserId: 40743,
            Id: 1821
        },
        Site: {
            SiteNumber: "000000000000002",
            Id: 13
        },
        RelatedCall: {},
        CustomerId: 19,
        AssignedToId: 40743,
        SiteId: 13,
        RelatedCallId: null,
        Id: 33479,
        OrderTypeId: null
    },
    {
        OrderNumber: "31119",
        OrderDate: toLocalDate("2018-12-05T00:00:00Z"),
        OrderStatusId: 12,
        TechOrderStatus: null,
        JobNumber: null,
        OrderedBy: null,
        WaitingForId: null,
        ReasonId: null,
        PriorityId: null,
        TotalPrice: null,
        TotalCost: null,
        SiteAddress1: "Testing Address",
        SiteAddress2: null,
        SiteAddress3: null,
        SiteCity: "Mequon",
        SiteRegion: "WI",
        SitePostalCode: "53092",
        ShipViaId: 1,
        RegionId: 1,
        DivisionId: null,
        Customer: {
            CustomerName: "Holly Romine",
            CustomerNumber: "194",
            OpenOrderAmount: 0,
            Id: 436
        },
        AssignedTo: {
            FirstName: "Daniel",
            LastName: "Greuel",
            UserId: 40743,
            Id: 1821
        },
        Site: {
            SiteNumber: "Billing",
            Id: 546
        },
        RelatedCall: {},
        CustomerId: 436,
        AssignedToId: 40743,
        SiteId: 546,
        RelatedCallId: null,
        Id: 33485,
        OrderTypeId: null
    },
    {
        OrderNumber: "31084",
        OrderDate: toLocalDate("2018-11-28T00:00:00Z"),
        OrderStatusId: 12,
        TechOrderStatus: "",
        JobNumber: null,
        OrderedBy: null,
        WaitingForId: null,
        ReasonId: null,
        PriorityId: 2,
        TotalPrice: null,
        TotalCost: null,
        SiteAddress1: "75 Middlesex Turnpike",
        SiteAddress2: "",
        SiteAddress3: null,
        SiteCity: "Burlington",
        SiteRegion: "WI",
        SitePostalCode: "54803",
        ShipViaId: 1,
        RegionId: 1,
        DivisionId: null,
        Customer: {
            CustomerName: "Burlington Mall",
            CustomerNumber: "000000012030",
            OpenOrderAmount: 5329.74,
            Id: 13
        },
        AssignedTo: {
            FirstName: "Daniel",
            LastName: "Greuel",
            UserId: 40743,
            Id: 1821
        },
        Site: {
            SiteNumber: "Billing",
            Id: 2
        },
        RelatedCall: {
            Id: 39048
        },
        CustomerId: 13,
        AssignedToId: 40743,
        SiteId: 2,
        RelatedCallId: 39048,
        Id: 32454,
        OrderTypeId: null
    },
    {
        OrderNumber: "31086",
        OrderDate: toLocalDate("2018-11-29T00:00:00Z"),
        OrderStatusId: 12,
        TechOrderStatus: null,
        JobNumber: null,
        OrderedBy: "New Dood",
        WaitingForId: null,
        ReasonId: null,
        PriorityId: null,
        TotalPrice: 25.83,
        TotalCost: 0,
        SiteAddress1: null,
        SiteAddress2: null,
        SiteAddress3: null,
        SiteCity: null,
        SiteRegion: null,
        SitePostalCode: null,
        ShipViaId: 228,
        RegionId: 6,
        DivisionId: null,
        Customer: {
            CustomerName: "NewDood",
            CustomerNumber: "10000000200",
            OpenOrderAmount: 72.83,
            Id: 2109
        },
        AssignedTo: {
            FirstName: "Daniel",
            LastName: "Greuel",
            UserId: 40743,
            Id: 1821
        },
        Site: {
            SiteNumber: "Billing",
            Id: 16368
        },
        RelatedCall: {},
        CustomerId: 2109,
        AssignedToId: 40743,
        SiteId: 16368,
        RelatedCallId: null,
        Id: 32456,
        OrderTypeId: null
    },
    {
        OrderNumber: "31087",
        OrderDate: toLocalDate("2018-11-29T00:00:00Z"),
        OrderStatusId: 12,
        TechOrderStatus: null,
        JobNumber: null,
        OrderedBy: "New Dood",
        WaitingForId: null,
        ReasonId: 8,
        PriorityId: 2,
        TotalPrice: 47,
        TotalCost: 0,
        SiteAddress1: null,
        SiteAddress2: null,
        SiteAddress3: null,
        SiteCity: null,
        SiteRegion: null,
        SitePostalCode: null,
        ShipViaId: 4,
        RegionId: 6,
        DivisionId: null,
        Customer: {
            CustomerName: "NewDood",
            CustomerNumber: "10000000200",
            OpenOrderAmount: 72.83,
            Id: 2109
        },
        AssignedTo: {
            FirstName: "Daniel",
            LastName: "Greuel",
            UserId: 40743,
            Id: 1821
        },
        Site: {
            SiteNumber: "Billing",
            Id: 16368
        },
        RelatedCall: {},
        CustomerId: 2109,
        AssignedToId: 40743,
        SiteId: 16368,
        RelatedCallId: null,
        Id: 32457,
        OrderTypeId: null
    },
    {
        OrderNumber: "31088",
        OrderDate: toLocalDate("2018-11-29T00:00:00Z"),
        OrderStatusId: 12,
        TechOrderStatus: null,
        JobNumber: null,
        OrderedBy: null,
        WaitingForId: null,
        ReasonId: null,
        PriorityId: null,
        TotalPrice: null,
        TotalCost: null,
        SiteAddress1: "3415 Saemann Ave2",
        SiteAddress2: "",
        SiteAddress3: "",
        SiteCity: "Sheboygan2",
        SiteRegion: "WI",
        SitePostalCode: "53081",
        ShipViaId: 8,
        RegionId: 1,
        DivisionId: null,
        Customer: {
            CustomerName: "Tri-State Paving",
            CustomerNumber: "000000000001",
            OpenOrderAmount: 35128708.55,
            Id: 1
        },
        AssignedTo: {
            FirstName: "Daniel",
            LastName: "Greuel",
            UserId: 40743,
            Id: 1821
        },
        Site: {
            SiteNumber: "Billing",
            Id: 19
        },
        RelatedCall: {},
        CustomerId: 1,
        AssignedToId: 40743,
        SiteId: 19,
        RelatedCallId: null,
        Id: 32458,
        OrderTypeId: null
    },
    {
        OrderNumber: "31008",
        OrderDate: toLocalDate("2018-11-12T00:00:00Z"),
        OrderStatusId: 12,
        TechOrderStatus: null,
        JobNumber: null,
        OrderedBy: null,
        WaitingForId: null,
        ReasonId: null,
        PriorityId: null,
        TotalPrice: null,
        TotalCost: null,
        SiteAddress1: "215 Perry Hill Road ",
        SiteAddress2: null,
        SiteAddress3: null,
        SiteCity: "Montgomery",
        SiteRegion: "Alabama",
        SitePostalCode: "36109",
        ShipViaId: 1,
        RegionId: 1,
        DivisionId: null,
        Customer: {
            CustomerName: "Saratoga Medical Hospital",
            CustomerNumber: "000000000002",
            OpenOrderAmount: 237735.13,
            Id: 2
        },
        AssignedTo: {
            FirstName: "Daniel",
            LastName: "Greuel",
            UserId: 40743,
            Id: 1821
        },
        Site: {
            SiteNumber: "2",
            Id: 290
        },
        RelatedCall: {},
        CustomerId: 2,
        AssignedToId: 40743,
        SiteId: 290,
        RelatedCallId: null,
        Id: 31383,
        OrderTypeId: null
    },
    {
        OrderNumber: "31009",
        OrderDate: toLocalDate("2018-11-12T00:00:00Z"),
        OrderStatusId: 12,
        TechOrderStatus: null,
        JobNumber: null,
        OrderedBy: null,
        WaitingForId: null,
        ReasonId: null,
        PriorityId: null,
        TotalPrice: null,
        TotalCost: null,
        SiteAddress1: "1818 Wisconsin Ave",
        SiteAddress2: "Suite 100",
        SiteAddress3: "MS0001",
        SiteCity: "Grafton",
        SiteRegion: "WI",
        SitePostalCode: "53024",
        ShipViaId: 1,
        RegionId: 1,
        DivisionId: null,
        Customer: {
            CustomerName: "Saratoga Medical Hospital",
            CustomerNumber: "000000000002",
            OpenOrderAmount: 237735.13,
            Id: 2
        },
        AssignedTo: {
            FirstName: "Daniel",
            LastName: "Greuel",
            UserId: 40743,
            Id: 1821
        },
        Site: {
            SiteNumber: "Billing",
            Id: 61
        },
        RelatedCall: {},
        CustomerId: 2,
        AssignedToId: 40743,
        SiteId: 61,
        RelatedCallId: null,
        Id: 31384,
        OrderTypeId: null
    },
    {
        OrderNumber: "31012",
        OrderDate: toLocalDate("2018-11-12T00:00:00Z"),
        OrderStatusId: 12,
        TechOrderStatus: null,
        JobNumber: null,
        OrderedBy: null,
        WaitingForId: null,
        ReasonId: null,
        PriorityId: null,
        TotalPrice: null,
        TotalCost: null,
        SiteAddress1: null,
        SiteAddress2: null,
        SiteAddress3: null,
        SiteCity: null,
        SiteRegion: null,
        SitePostalCode: null,
        ShipViaId: 230,
        RegionId: 1,
        DivisionId: null,
        Customer: {
            CustomerName: "ABC",
            CustomerNumber: "9547564645678",
            OpenOrderAmount: 0,
            Id: 2182
        },
        AssignedTo: {
            FirstName: "Daniel",
            LastName: "Greuel",
            UserId: 40743,
            Id: 1821
        },
        Site: {
            SiteNumber: "Billing",
            Id: 16527
        },
        RelatedCall: {},
        CustomerId: 2182,
        AssignedToId: 40743,
        SiteId: 16527,
        RelatedCallId: null,
        Id: 31387,
        OrderTypeId: null
    },
    {
        OrderNumber: "31014",
        OrderDate: toLocalDate("2018-11-14T00:00:00Z"),
        OrderStatusId: 12,
        TechOrderStatus: null,
        JobNumber: null,
        OrderedBy: null,
        WaitingForId: null,
        ReasonId: null,
        PriorityId: null,
        TotalPrice: null,
        TotalCost: null,
        SiteAddress1: null,
        SiteAddress2: null,
        SiteAddress3: null,
        SiteCity: null,
        SiteRegion: null,
        SitePostalCode: null,
        ShipViaId: 147,
        RegionId: 1,
        DivisionId: 3,
        Customer: {
            CustomerName: "ee580300-9af1-11e6-bc1a-005056c00008",
            CustomerNumber: "ee580300-9af1-11e6-bc1a-005056c00008",
            OpenOrderAmount: 0,
            Id: 1959
        },
        AssignedTo: {
            FirstName: "Daniel",
            LastName: "Greuel",
            UserId: 40743,
            Id: 1821
        },
        Site: {
            SiteNumber: "Billing",
            Id: 16220
        },
        RelatedCall: {},
        CustomerId: 1959,
        AssignedToId: 40743,
        SiteId: 16220,
        RelatedCallId: null,
        Id: 31389,
        OrderTypeId: null
    },
    {
        OrderNumber: "31172",
        OrderDate: toLocalDate("2018-12-17T00:00:00Z"),
        OrderStatusId: 16,
        TechOrderStatus: null,
        JobNumber: null,
        OrderedBy: null,
        WaitingForId: null,
        ReasonId: null,
        PriorityId: null,
        TotalPrice: null,
        TotalCost: null,
        SiteAddress1: "BLARG",
        SiteAddress2: null,
        SiteAddress3: null,
        SiteCity: null,
        SiteRegion: null,
        SitePostalCode: null,
        ShipViaId: 206,
        RegionId: 1,
        DivisionId: 17,
        Customer: {
            CustomerName: "Legal Sea Foods",
            CustomerNumber: "000000012065",
            OpenOrderAmount: 231460.24,
            Id: 78
        },
        AssignedTo: {
            FirstName: "Daniel",
            LastName: "Greuel",
            UserId: 40743,
            Id: 1821
        },
        Site: {
            SiteNumber: "9",
            Id: 1575
        },
        RelatedCall: {},
        CustomerId: 78,
        AssignedToId: 40743,
        SiteId: 1575,
        RelatedCallId: null,
        Id: 33538,
        OrderTypeId: null
    },
    {
        OrderNumber: "31178",
        OrderDate: toLocalDate("2018-12-17T00:00:00Z"),
        OrderStatusId: 12,
        TechOrderStatus: null,
        JobNumber: null,
        OrderedBy: null,
        WaitingForId: null,
        ReasonId: null,
        PriorityId: null,
        TotalPrice: null,
        TotalCost: null,
        SiteAddress1: "123 Lane ",
        SiteAddress2: null,
        SiteAddress3: null,
        SiteCity: "Snackville",
        SiteRegion: "Treatscosin",
        SitePostalCode: "987",
        ShipViaId: 1,
        RegionId: 1,
        DivisionId: null,
        Customer: {
            CustomerName: "GAP Incorporated",
            CustomerNumber: "000000012035",
            OpenOrderAmount: 1281.6,
            Id: 14
        },
        AssignedTo: {
            FirstName: "Daniel",
            LastName: "Greuel",
            UserId: 40743,
            Id: 1821
        },
        Site: {
            SiteNumber: "Billing",
            Id: 1
        },
        RelatedCall: {},
        CustomerId: 14,
        AssignedToId: 40743,
        SiteId: 1,
        RelatedCallId: null,
        Id: 33544,
        OrderTypeId: null
    },
    {
        OrderNumber: "31179",
        OrderDate: toLocalDate("2018-12-17T00:00:00Z"),
        OrderStatusId: 12,
        TechOrderStatus: null,
        JobNumber: null,
        OrderedBy: null,
        WaitingForId: null,
        ReasonId: null,
        PriorityId: null,
        TotalPrice: null,
        TotalCost: null,
        SiteAddress1: "3415 Saemann Ave2",
        SiteAddress2: "",
        SiteAddress3: "",
        SiteCity: "Sheboygan2",
        SiteRegion: "WI",
        SitePostalCode: "53081",
        ShipViaId: 8,
        RegionId: 1,
        DivisionId: null,
        Customer: {
            CustomerName: "Tri-State Paving",
            CustomerNumber: "000000000001",
            OpenOrderAmount: 35128708.55,
            Id: 1
        },
        AssignedTo: {
            FirstName: "Daniel",
            LastName: "Greuel",
            UserId: 40743,
            Id: 1821
        },
        Site: {
            SiteNumber: "Billing",
            Id: 19
        },
        RelatedCall: {},
        CustomerId: 1,
        AssignedToId: 40743,
        SiteId: 19,
        RelatedCallId: null,
        Id: 33545,
        OrderTypeId: null
    },
    {
        OrderNumber: "31180",
        OrderDate: toLocalDate("2018-12-17T00:00:00Z"),
        OrderStatusId: 12,
        TechOrderStatus: null,
        JobNumber: null,
        OrderedBy: null,
        WaitingForId: null,
        ReasonId: null,
        PriorityId: null,
        TotalPrice: null,
        TotalCost: null,
        SiteAddress1: "355009 Plymouth Road1",
        SiteAddress2: "",
        SiteAddress3: null,
        SiteCity: "Livonia",
        SiteRegion: "MI",
        SitePostalCode: "48150",
        ShipViaId: 1,
        RegionId: 1,
        DivisionId: null,
        Customer: {
            CustomerName: "Ford Motor Company",
            CustomerNumber: "000000000150",
            OpenOrderAmount: 9075.6,
            Id: 34
        },
        AssignedTo: {
            FirstName: "Daniel",
            LastName: "Greuel",
            UserId: 40743,
            Id: 1821
        },
        Site: {
            SiteNumber: "Billing",
            Id: 3
        },
        RelatedCall: {},
        CustomerId: 34,
        AssignedToId: 40743,
        SiteId: 3,
        RelatedCallId: null,
        Id: 33546,
        OrderTypeId: null
    },
    {
        OrderNumber: "31181",
        OrderDate: toLocalDate("2018-12-17T00:00:00Z"),
        OrderStatusId: 12,
        TechOrderStatus: null,
        JobNumber: null,
        OrderedBy: null,
        WaitingForId: null,
        ReasonId: null,
        PriorityId: null,
        TotalPrice: null,
        TotalCost: null,
        SiteAddress1: "910 Gateway Commons Circle",
        SiteAddress2: "",
        SiteAddress3: null,
        SiteCity: "Wake Forest",
        SiteRegion: "NC",
        SitePostalCode: "27587",
        ShipViaId: 1,
        RegionId: 1,
        DivisionId: null,
        Customer: {
            CustomerName: "Tri-State Paving",
            CustomerNumber: "000000000001",
            OpenOrderAmount: 35128708.55,
            Id: 1
        },
        AssignedTo: {
            FirstName: "Daniel",
            LastName: "Greuel",
            UserId: 40743,
            Id: 1821
        },
        Site: {
            SiteNumber: "Billing",
            Id: 19
        },
        RelatedCall: {},
        CustomerId: 1,
        AssignedToId: 40743,
        SiteId: 19,
        RelatedCallId: null,
        Id: 33547,
        OrderTypeId: null
    },
    {
        OrderNumber: "31182",
        OrderDate: toLocalDate("2018-12-17T00:00:00Z"),
        OrderStatusId: 12,
        TechOrderStatus: null,
        JobNumber: null,
        OrderedBy: null,
        WaitingForId: null,
        ReasonId: null,
        PriorityId: null,
        TotalPrice: null,
        TotalCost: null,
        SiteAddress1: "3415 Saemann Ave2",
        SiteAddress2: "",
        SiteAddress3: "",
        SiteCity: "Sheboygan2",
        SiteRegion: "WI",
        SitePostalCode: "53081",
        ShipViaId: 8,
        RegionId: 1,
        DivisionId: null,
        Customer: {
            CustomerName: "Tri-State Paving",
            CustomerNumber: "000000000001",
            OpenOrderAmount: 35128708.55,
            Id: 1
        },
        AssignedTo: {
            FirstName: "Daniel",
            LastName: "Greuel",
            UserId: 40743,
            Id: 1821
        },
        Site: {
            SiteNumber: "Billing",
            Id: 19
        },
        RelatedCall: {},
        CustomerId: 1,
        AssignedToId: 40743,
        SiteId: 19,
        RelatedCallId: null,
        Id: 33548,
        OrderTypeId: null
    },
    {
        OrderNumber: "31183",
        OrderDate: toLocalDate("2018-12-17T00:00:00Z"),
        OrderStatusId: 12,
        TechOrderStatus: null,
        JobNumber: null,
        OrderedBy: null,
        WaitingForId: null,
        ReasonId: null,
        PriorityId: null,
        TotalPrice: null,
        TotalCost: null,
        SiteAddress1: "413 Old Billerica Road",
        SiteAddress2: "",
        SiteAddress3: null,
        SiteCity: "Bedford",
        SiteRegion: "MA",
        SitePostalCode: "02114",
        ShipViaId: 1,
        RegionId: 1,
        DivisionId: null,
        Customer: {
            CustomerName: "GAP Incorporated",
            CustomerNumber: "000000012035",
            OpenOrderAmount: 1281.6,
            Id: 14
        },
        AssignedTo: {
            FirstName: "Daniel",
            LastName: "Greuel",
            UserId: 40743,
            Id: 1821
        },
        Site: {
            SiteNumber: "000000000000002",
            Id: 8
        },
        RelatedCall: {},
        CustomerId: 14,
        AssignedToId: 40743,
        SiteId: 8,
        RelatedCallId: null,
        Id: 33549,
        OrderTypeId: null
    },
    {
        OrderNumber: "31186",
        OrderDate: toLocalDate("2018-12-19T00:00:00Z"),
        OrderStatusId: 12,
        TechOrderStatus: null,
        JobNumber: null,
        OrderedBy: null,
        WaitingForId: null,
        ReasonId: null,
        PriorityId: 2,
        TotalPrice: null,
        TotalCost: null,
        SiteAddress1: "3405 Saemann Ave",
        SiteAddress2: null,
        SiteAddress3: null,
        SiteCity: "Sheboygan",
        SiteRegion: "WI",
        SitePostalCode: "53081",
        ShipViaId: 1,
        RegionId: 1,
        DivisionId: 17,
        Customer: {
            CustomerName: "Legal Sea Foods",
            CustomerNumber: "000000012065",
            OpenOrderAmount: 231460.24,
            Id: 78
        },
        AssignedTo: {
            FirstName: "Daniel",
            LastName: "Greuel",
            UserId: 40743,
            Id: 1821
        },
        Site: {
            SiteNumber: "9",
            Id: 1575
        },
        RelatedCall: {
            Id: 40163
        },
        CustomerId: 78,
        AssignedToId: 40743,
        SiteId: 1575,
        RelatedCallId: 40163,
        Id: 33552,
        OrderTypeId: null
    },
    {
        OrderNumber: "31218",
        OrderDate: toLocalDate("2019-01-02T00:00:00Z"),
        OrderStatusId: 12,
        TechOrderStatus: null,
        JobNumber: null,
        OrderedBy: null,
        WaitingForId: null,
        ReasonId: null,
        PriorityId: null,
        TotalPrice: 0,
        TotalCost: 0,
        SiteAddress1: "300 New Higway",
        SiteAddress2: "",
        SiteAddress3: null,
        SiteCity: "Hauppauge",
        SiteRegion: "NY",
        SitePostalCode: "11369",
        ShipViaId: 1,
        RegionId: 1,
        DivisionId: null,
        Customer: {
            CustomerName: "HBO Communications Center",
            CustomerNumber: "000000019617",
            OpenOrderAmount: 0,
            Id: 29
        },
        AssignedTo: {
            FirstName: "Daniel",
            LastName: "Greuel",
            UserId: 40743,
            Id: 1821
        },
        Site: {
            SiteNumber: "Billing",
            Id: 73
        },
        RelatedCall: {},
        CustomerId: 29,
        AssignedToId: 40743,
        SiteId: 73,
        RelatedCallId: null,
        Id: 33584,
        OrderTypeId: null
    },
    {
        OrderNumber: "31219",
        OrderDate: toLocalDate("2019-01-02T00:00:00Z"),
        OrderStatusId: 12,
        TechOrderStatus: null,
        JobNumber: null,
        OrderedBy: null,
        WaitingForId: null,
        ReasonId: null,
        PriorityId: null,
        TotalPrice: null,
        TotalCost: null,
        SiteAddress1: "300 New Higway",
        SiteAddress2: "",
        SiteAddress3: null,
        SiteCity: "Hauppauge",
        SiteRegion: "NY",
        SitePostalCode: "11369",
        ShipViaId: 1,
        RegionId: 1,
        DivisionId: null,
        Customer: {
            CustomerName: "HBO Communications Center",
            CustomerNumber: "000000019617",
            OpenOrderAmount: 0,
            Id: 29
        },
        AssignedTo: {
            FirstName: "Daniel",
            LastName: "Greuel",
            UserId: 40743,
            Id: 1821
        },
        Site: {
            SiteNumber: "Billing",
            Id: 73
        },
        RelatedCall: {},
        CustomerId: 29,
        AssignedToId: 40743,
        SiteId: 73,
        RelatedCallId: null,
        Id: 33585,
        OrderTypeId: null
    },
    {
        OrderNumber: "31226",
        OrderDate: toLocalDate("2019-01-03T00:00:00Z"),
        OrderStatusId: 12,
        TechOrderStatus: null,
        JobNumber: null,
        OrderedBy: null,
        WaitingForId: null,
        ReasonId: 19,
        PriorityId: null,
        TotalPrice: null,
        TotalCost: null,
        SiteAddress1: "123 Lane ",
        SiteAddress2: null,
        SiteAddress3: null,
        SiteCity: "Snackville",
        SiteRegion: "Treatscosin",
        SitePostalCode: "987",
        ShipViaId: 1,
        RegionId: 1,
        DivisionId: null,
        Customer: {
            CustomerName: "GAP Incorporated",
            CustomerNumber: "000000012035",
            OpenOrderAmount: 1281.6,
            Id: 14
        },
        AssignedTo: {
            FirstName: "Daniel",
            LastName: "Greuel",
            UserId: 40743,
            Id: 1821
        },
        Site: {
            SiteNumber: "Billing",
            Id: 1
        },
        RelatedCall: {},
        CustomerId: 14,
        AssignedToId: 40743,
        SiteId: 1,
        RelatedCallId: null,
        Id: 33592,
        OrderTypeId: null
    },
    {
        OrderNumber: "31227",
        OrderDate: toLocalDate("2019-01-03T00:00:00Z"),
        OrderStatusId: 12,
        TechOrderStatus: null,
        JobNumber: null,
        OrderedBy: null,
        WaitingForId: null,
        ReasonId: null,
        PriorityId: null,
        TotalPrice: null,
        TotalCost: null,
        SiteAddress1: "123 Lane ",
        SiteAddress2: null,
        SiteAddress3: null,
        SiteCity: "Snackville",
        SiteRegion: "Treatscosin",
        SitePostalCode: "987",
        ShipViaId: 1,
        RegionId: 1,
        DivisionId: null,
        Customer: {
            CustomerName: "GAP Incorporated",
            CustomerNumber: "000000012035",
            OpenOrderAmount: 1281.6,
            Id: 14
        },
        AssignedTo: {
            FirstName: "Daniel",
            LastName: "Greuel",
            UserId: 40743,
            Id: 1821
        },
        Site: {
            SiteNumber: "Billing",
            Id: 1
        },
        RelatedCall: {},
        CustomerId: 14,
        AssignedToId: 40743,
        SiteId: 1,
        RelatedCallId: null,
        Id: 33593,
        OrderTypeId: null
    },
    {
        OrderNumber: "31228",
        OrderDate: toLocalDate("2019-01-03T00:00:00Z"),
        OrderStatusId: 12,
        TechOrderStatus: null,
        JobNumber: null,
        OrderedBy: null,
        WaitingForId: null,
        ReasonId: null,
        PriorityId: 2,
        TotalPrice: null,
        TotalCost: null,
        SiteAddress1: "123 Lane ",
        SiteAddress2: null,
        SiteAddress3: null,
        SiteCity: "Snackville",
        SiteRegion: "Treatscosin",
        SitePostalCode: "987",
        ShipViaId: 1,
        RegionId: 1,
        DivisionId: null,
        Customer: {
            CustomerName: "GAP Incorporated",
            CustomerNumber: "000000012035",
            OpenOrderAmount: 1281.6,
            Id: 14
        },
        AssignedTo: {
            FirstName: "Daniel",
            LastName: "Greuel",
            UserId: 40743,
            Id: 1821
        },
        Site: {
            SiteNumber: "Billing",
            Id: 1
        },
        RelatedCall: {
            Id: 40212
        },
        CustomerId: 14,
        AssignedToId: 40743,
        SiteId: 1,
        RelatedCallId: 40212,
        Id: 33594,
        OrderTypeId: null
    },
    {
        OrderNumber: "31229",
        OrderDate: toLocalDate("2019-01-03T00:00:00Z"),
        OrderStatusId: 12,
        TechOrderStatus: null,
        JobNumber: null,
        OrderedBy: null,
        WaitingForId: null,
        ReasonId: null,
        PriorityId: null,
        TotalPrice: null,
        TotalCost: null,
        SiteAddress1: "123 Lane ",
        SiteAddress2: null,
        SiteAddress3: null,
        SiteCity: "Snackville",
        SiteRegion: "Treatscosin",
        SitePostalCode: "987",
        ShipViaId: 1,
        RegionId: 1,
        DivisionId: null,
        Customer: {
            CustomerName: "GAP Incorporated",
            CustomerNumber: "000000012035",
            OpenOrderAmount: 1281.6,
            Id: 14
        },
        AssignedTo: {
            FirstName: "Daniel",
            LastName: "Greuel",
            UserId: 40743,
            Id: 1821
        },
        Site: {
            SiteNumber: "Billing",
            Id: 1
        },
        RelatedCall: {},
        CustomerId: 14,
        AssignedToId: 40743,
        SiteId: 1,
        RelatedCallId: null,
        Id: 33595,
        OrderTypeId: null
    },
    {
        OrderNumber: "31230",
        OrderDate: toLocalDate("2019-01-03T00:00:00Z"),
        OrderStatusId: 12,
        TechOrderStatus: null,
        JobNumber: null,
        OrderedBy: null,
        WaitingForId: null,
        ReasonId: null,
        PriorityId: null,
        TotalPrice: 0,
        TotalCost: 0,
        SiteAddress1: "123 Lane ",
        SiteAddress2: null,
        SiteAddress3: null,
        SiteCity: "Snackville",
        SiteRegion: "Treatscosin",
        SitePostalCode: "987",
        ShipViaId: 1,
        RegionId: 1,
        DivisionId: null,
        Customer: {
            CustomerName: "GAP Incorporated",
            CustomerNumber: "000000012035",
            OpenOrderAmount: 1281.6,
            Id: 14
        },
        AssignedTo: {
            FirstName: "Daniel",
            LastName: "Greuel",
            UserId: 40743,
            Id: 1821
        },
        Site: {
            SiteNumber: "Billing",
            Id: 1
        },
        RelatedCall: {},
        CustomerId: 14,
        AssignedToId: 40743,
        SiteId: 1,
        RelatedCallId: null,
        Id: 33596,
        OrderTypeId: null
    },
    {
        OrderNumber: "31231",
        OrderDate: toLocalDate("2019-01-03T00:00:00Z"),
        OrderStatusId: 12,
        TechOrderStatus: null,
        JobNumber: null,
        OrderedBy: null,
        WaitingForId: null,
        ReasonId: null,
        PriorityId: null,
        TotalPrice: 15,
        TotalCost: 2,
        SiteAddress1: "123 Lane ",
        SiteAddress2: null,
        SiteAddress3: null,
        SiteCity: "Snackville",
        SiteRegion: "Treatscosin",
        SitePostalCode: "987",
        ShipViaId: 1,
        RegionId: 1,
        DivisionId: null,
        Customer: {
            CustomerName: "GAP Incorporated",
            CustomerNumber: "000000012035",
            OpenOrderAmount: 1281.6,
            Id: 14
        },
        AssignedTo: {
            FirstName: "Daniel",
            LastName: "Greuel",
            UserId: 40743,
            Id: 1821
        },
        Site: {
            SiteNumber: "Billing",
            Id: 1
        },
        RelatedCall: {},
        CustomerId: 14,
        AssignedToId: 40743,
        SiteId: 1,
        RelatedCallId: null,
        Id: 33597,
        OrderTypeId: null
    },
    {
        OrderNumber: "33015",
        OrderDate: toLocalDate("2019-01-21T00:00:00Z"),
        OrderStatusId: 12,
        TechOrderStatus: null,
        JobNumber: null,
        OrderedBy: null,
        WaitingForId: null,
        ReasonId: null,
        PriorityId: null,
        TotalPrice: 0,
        TotalCost: 0,
        SiteAddress1: "1818 Wisconsin Ave",
        SiteAddress2: "Suite 100",
        SiteAddress3: "MS0001",
        SiteCity: "Grafton",
        SiteRegion: "WI",
        SitePostalCode: "53024",
        ShipViaId: 1,
        RegionId: 1,
        DivisionId: null,
        Customer: {
            CustomerName: "Saratoga Medical Hospital",
            CustomerNumber: "000000000002",
            OpenOrderAmount: 237735.13,
            Id: 2
        },
        AssignedTo: {
            FirstName: "Daniel",
            LastName: "Greuel",
            UserId: 40743,
            Id: 1821
        },
        Site: {
            SiteNumber: "Billing",
            Id: 61
        },
        RelatedCall: {},
        CustomerId: 2,
        AssignedToId: 40743,
        SiteId: 61,
        RelatedCallId: null,
        Id: 33709,
        OrderTypeId: null
    },
    {
        OrderNumber: "33016",
        OrderDate: toLocalDate("2019-01-21T00:00:00Z"),
        OrderStatusId: 12,
        TechOrderStatus: null,
        JobNumber: null,
        OrderedBy: null,
        WaitingForId: null,
        ReasonId: null,
        PriorityId: null,
        TotalPrice: 10.9,
        TotalCost: 2,
        SiteAddress1: "Testing Address",
        SiteAddress2: null,
        SiteAddress3: null,
        SiteCity: "Mequon",
        SiteRegion: "WI",
        SitePostalCode: "53092",
        ShipViaId: 1,
        RegionId: 1,
        DivisionId: null,
        Customer: {
            CustomerName: "John Smith Home Design",
            CustomerNumber: "899",
            OpenOrderAmount: 10.9,
            Id: 1214
        },
        AssignedTo: {
            FirstName: "Daniel",
            LastName: "Greuel",
            UserId: 40743,
            Id: 1821
        },
        Site: {
            SiteNumber: "Billing",
            Id: 1163
        },
        RelatedCall: {},
        CustomerId: 1214,
        AssignedToId: 40743,
        SiteId: 1163,
        RelatedCallId: null,
        Id: 33711,
        OrderTypeId: null
    },
    {
        OrderNumber: "33025",
        OrderDate: toLocalDate("2019-01-29T00:00:00Z"),
        OrderStatusId: 12,
        TechOrderStatus: null,
        JobNumber: null,
        OrderedBy: null,
        WaitingForId: null,
        ReasonId: null,
        PriorityId: null,
        TotalPrice: 0,
        TotalCost: 15,
        SiteAddress1: "670 Manson St",
        SiteAddress2: "",
        SiteAddress3: null,
        SiteCity: "San Francisco",
        SiteRegion: "CA",
        SitePostalCode: "95782",
        ShipViaId: 1,
        RegionId: 1,
        DivisionId: null,
        Customer: {
            CustomerName: "21st Century enterprises",
            CustomerNumber: "000000000200",
            OpenOrderAmount: 658.9,
            Id: 35
        },
        AssignedTo: {
            FirstName: "Daniel",
            LastName: "Greuel",
            UserId: 40743,
            Id: 1821
        },
        Site: {
            SiteNumber: "Billing",
            Id: 4
        },
        RelatedCall: {},
        CustomerId: 35,
        AssignedToId: 40743,
        SiteId: 4,
        RelatedCallId: null,
        Id: 33721,
        OrderTypeId: null
    },
    {
        OrderNumber: "33026",
        OrderDate: toLocalDate("2019-01-28T00:00:00Z"),
        OrderStatusId: 12,
        TechOrderStatus: null,
        JobNumber: null,
        OrderedBy: null,
        WaitingForId: null,
        ReasonId: null,
        PriorityId: null,
        TotalPrice: null,
        TotalCost: null,
        SiteAddress1: "413 Old Billerica Road",
        SiteAddress2: "",
        SiteAddress3: null,
        SiteCity: "Bedford",
        SiteRegion: "MA",
        SitePostalCode: "02114",
        ShipViaId: 1,
        RegionId: 1,
        DivisionId: null,
        Customer: {
            CustomerName: "GAP Incorporated",
            CustomerNumber: "000000012035",
            OpenOrderAmount: 1281.6,
            Id: 14
        },
        AssignedTo: {
            FirstName: "Daniel",
            LastName: "Greuel",
            UserId: 40743,
            Id: 1821
        },
        Site: {
            SiteNumber: "000000000000002",
            Id: 8
        },
        RelatedCall: {},
        CustomerId: 14,
        AssignedToId: 40743,
        SiteId: 8,
        RelatedCallId: null,
        Id: 33725,
        OrderTypeId: null
    },
    {
        OrderNumber: "33046",
        OrderDate: toLocalDate("2019-02-06T00:00:00Z"),
        OrderStatusId: 12,
        TechOrderStatus: null,
        JobNumber: null,
        OrderedBy: null,
        WaitingForId: null,
        ReasonId: null,
        PriorityId: null,
        TotalPrice: null,
        TotalCost: null,
        SiteAddress1: "3415 Saemann Ave2",
        SiteAddress2: "",
        SiteAddress3: "",
        SiteCity: "Sheboygan2",
        SiteRegion: "WI",
        SitePostalCode: "53081",
        ShipViaId: 8,
        RegionId: 1,
        DivisionId: null,
        Customer: {
            CustomerName: "Tri-State Paving",
            CustomerNumber: "000000000001",
            OpenOrderAmount: 35128708.55,
            Id: 1
        },
        AssignedTo: {
            FirstName: "Daniel",
            LastName: "Greuel",
            UserId: 40743,
            Id: 1821
        },
        Site: {
            SiteNumber: "Billing",
            Id: 19
        },
        RelatedCall: {},
        CustomerId: 1,
        AssignedToId: 40743,
        SiteId: 19,
        RelatedCallId: null,
        Id: 33746,
        OrderTypeId: null
    },
    {
        OrderNumber: "33047",
        OrderDate: toLocalDate("2019-02-07T00:00:00Z"),
        OrderStatusId: 12,
        TechOrderStatus: null,
        JobNumber: null,
        OrderedBy: null,
        WaitingForId: null,
        ReasonId: null,
        PriorityId: 11,
        TotalPrice: null,
        TotalCost: null,
        SiteAddress1: "3415 Saemann Ave2",
        SiteAddress2: "",
        SiteAddress3: "",
        SiteCity: "Sheboygan2",
        SiteRegion: "WI",
        SitePostalCode: "53081",
        ShipViaId: 8,
        RegionId: 1,
        DivisionId: null,
        Customer: {
            CustomerName: "Tri-State Paving",
            CustomerNumber: "000000000001",
            OpenOrderAmount: 35128708.55,
            Id: 1
        },
        AssignedTo: {
            FirstName: "Daniel",
            LastName: "Greuel",
            UserId: 40743,
            Id: 1821
        },
        Site: {
            SiteNumber: "Billing",
            Id: 19
        },
        RelatedCall: {},
        CustomerId: 1,
        AssignedToId: 40743,
        SiteId: 19,
        RelatedCallId: null,
        Id: 33747,
        OrderTypeId: null
    },
    {
        OrderNumber: "33062",
        OrderDate: toLocalDate("2019-02-11T00:00:00Z"),
        OrderStatusId: 12,
        TechOrderStatus: null,
        JobNumber: null,
        OrderedBy: null,
        WaitingForId: null,
        ReasonId: null,
        PriorityId: null,
        TotalPrice: null,
        TotalCost: null,
        SiteAddress1: "123 Lane ",
        SiteAddress2: null,
        SiteAddress3: null,
        SiteCity: "Snackville",
        SiteRegion: "Treatscosin",
        SitePostalCode: "987",
        ShipViaId: 1,
        RegionId: 1,
        DivisionId: null,
        Customer: {
            CustomerName: "GAP Incorporated",
            CustomerNumber: "000000012035",
            OpenOrderAmount: 1281.6,
            Id: 14
        },
        AssignedTo: {
            FirstName: "Daniel",
            LastName: "Greuel",
            UserId: 40743,
            Id: 1821
        },
        Site: {
            SiteNumber: "Billing",
            Id: 1
        },
        RelatedCall: {},
        CustomerId: 14,
        AssignedToId: 40743,
        SiteId: 1,
        RelatedCallId: null,
        Id: 33762,
        OrderTypeId: null
    },
    {
        OrderNumber: "33063",
        OrderDate: toLocalDate("2019-02-12T00:00:00Z"),
        OrderStatusId: 12,
        TechOrderStatus: null,
        JobNumber: null,
        OrderedBy: null,
        WaitingForId: null,
        ReasonId: null,
        PriorityId: null,
        TotalPrice: null,
        TotalCost: null,
        SiteAddress1: "123 Lane ",
        SiteAddress2: null,
        SiteAddress3: null,
        SiteCity: "Snackville",
        SiteRegion: "Treatscosin",
        SitePostalCode: "987",
        ShipViaId: 1,
        RegionId: 1,
        DivisionId: null,
        Customer: {
            CustomerName: "GAP Incorporated",
            CustomerNumber: "000000012035",
            OpenOrderAmount: 1281.6,
            Id: 14
        },
        AssignedTo: {
            FirstName: "Daniel",
            LastName: "Greuel",
            UserId: 40743,
            Id: 1821
        },
        Site: {
            SiteNumber: "Billing",
            Id: 1
        },
        RelatedCall: {},
        CustomerId: 14,
        AssignedToId: 40743,
        SiteId: 1,
        RelatedCallId: null,
        Id: 33763,
        OrderTypeId: null
    },
    {
        OrderNumber: "33109",
        OrderDate: toLocalDate("2019-02-19T00:00:00Z"),
        OrderStatusId: 12,
        TechOrderStatus: null,
        JobNumber: null,
        OrderedBy: null,
        WaitingForId: 3,
        ReasonId: null,
        PriorityId: null,
        TotalPrice: null,
        TotalCost: null,
        SiteAddress1: "75 Middlesex Turnpike",
        SiteAddress2: "",
        SiteAddress3: null,
        SiteCity: "Burlington",
        SiteRegion: "WI",
        SitePostalCode: "54803",
        ShipViaId: 1,
        RegionId: 1,
        DivisionId: null,
        Customer: {
            CustomerName: "Burlington Mall",
            CustomerNumber: "000000012030",
            OpenOrderAmount: 5329.74,
            Id: 13
        },
        AssignedTo: {
            FirstName: "Daniel",
            LastName: "Greuel",
            UserId: 40743,
            Id: 1821
        },
        Site: {
            SiteNumber: "Billing",
            Id: 2
        },
        RelatedCall: {},
        CustomerId: 13,
        AssignedToId: 40743,
        SiteId: 2,
        RelatedCallId: null,
        Id: 33809,
        OrderTypeId: null
    },
    {
        OrderNumber: "33112",
        OrderDate: toLocalDate("2019-02-19T00:00:00Z"),
        OrderStatusId: 12,
        TechOrderStatus: null,
        JobNumber: null,
        OrderedBy: null,
        WaitingForId: null,
        ReasonId: null,
        PriorityId: 1,
        TotalPrice: null,
        TotalCost: null,
        SiteAddress1: "BLARG",
        SiteAddress2: null,
        SiteAddress3: null,
        SiteCity: null,
        SiteRegion: null,
        SitePostalCode: null,
        ShipViaId: 206,
        RegionId: 435,
        DivisionId: 17,
        Customer: {
            CustomerName: "Legal Sea Foods",
            CustomerNumber: "000000012065",
            OpenOrderAmount: 231460.24,
            Id: 78
        },
        AssignedTo: {
            FirstName: "Daniel",
            LastName: "Greuel",
            UserId: 40743,
            Id: 1821
        },
        Site: {
            SiteNumber: "9",
            Id: 1575
        },
        RelatedCall: {},
        CustomerId: 78,
        AssignedToId: 40743,
        SiteId: 1575,
        RelatedCallId: null,
        Id: 33812,
        OrderTypeId: null
    },
    {
        OrderNumber: "31127",
        OrderDate: toLocalDate("2018-12-05T00:00:00Z"),
        OrderStatusId: 12,
        TechOrderStatus: null,
        JobNumber: null,
        OrderedBy: null,
        WaitingForId: null,
        ReasonId: null,
        PriorityId: null,
        TotalPrice: null,
        TotalCost: null,
        SiteAddress1: "B",
        SiteAddress2: "C",
        SiteAddress3: "D",
        SiteCity: "E",
        SiteRegion: "F",
        SitePostalCode: "G",
        ShipViaId: 1,
        RegionId: 1,
        DivisionId: null,
        Customer: {
            CustomerName: "Wastewater Treatment of LA",
            CustomerNumber: "WTLA",
            OpenOrderAmount: 40466.12,
            Id: 9
        },
        AssignedTo: {
            FirstName: "Daniel",
            LastName: "Greuel",
            UserId: 40743,
            Id: 1821
        },
        Site: {
            SiteNumber: "000000000000001",
            Id: 14
        },
        RelatedCall: {},
        CustomerId: 9,
        AssignedToId: 40743,
        SiteId: 14,
        RelatedCallId: null,
        Id: 33493,
        OrderTypeId: null
    },
    {
        OrderNumber: "31128",
        OrderDate: toLocalDate("2018-12-05T00:00:00Z"),
        OrderStatusId: 12,
        TechOrderStatus: null,
        JobNumber: null,
        OrderedBy: null,
        WaitingForId: null,
        ReasonId: null,
        PriorityId: null,
        TotalPrice: null,
        TotalCost: null,
        SiteAddress1: "123 Lane ",
        SiteAddress2: null,
        SiteAddress3: null,
        SiteCity: "Snackville",
        SiteRegion: "Treatscosin",
        SitePostalCode: "987",
        ShipViaId: 1,
        RegionId: 1,
        DivisionId: null,
        Customer: {
            CustomerName: "GAP Incorporated",
            CustomerNumber: "000000012035",
            OpenOrderAmount: 1281.6,
            Id: 14
        },
        AssignedTo: {
            FirstName: "Daniel",
            LastName: "Greuel",
            UserId: 40743,
            Id: 1821
        },
        Site: {
            SiteNumber: "Billing",
            Id: 1
        },
        RelatedCall: {},
        CustomerId: 14,
        AssignedToId: 40743,
        SiteId: 1,
        RelatedCallId: null,
        Id: 33494,
        OrderTypeId: null
    },
    {
        OrderNumber: "31129",
        OrderDate: toLocalDate("2018-12-05T00:00:00Z"),
        OrderStatusId: 12,
        TechOrderStatus: null,
        JobNumber: null,
        OrderedBy: null,
        WaitingForId: null,
        ReasonId: null,
        PriorityId: null,
        TotalPrice: null,
        TotalCost: null,
        SiteAddress1: "123 Lane ",
        SiteAddress2: null,
        SiteAddress3: null,
        SiteCity: "Snackville",
        SiteRegion: "Treatscosin",
        SitePostalCode: "987",
        ShipViaId: 1,
        RegionId: 1,
        DivisionId: null,
        Customer: {
            CustomerName: "GAP Incorporated",
            CustomerNumber: "000000012035",
            OpenOrderAmount: 1281.6,
            Id: 14
        },
        AssignedTo: {
            FirstName: "Daniel",
            LastName: "Greuel",
            UserId: 40743,
            Id: 1821
        },
        Site: {
            SiteNumber: "Billing",
            Id: 1
        },
        RelatedCall: {},
        CustomerId: 14,
        AssignedToId: 40743,
        SiteId: 1,
        RelatedCallId: null,
        Id: 33495,
        OrderTypeId: null
    },
    {
        OrderNumber: "31165",
        OrderDate: toLocalDate("2018-12-13T00:00:00Z"),
        OrderStatusId: 12,
        TechOrderStatus: null,
        JobNumber: null,
        OrderedBy: null,
        WaitingForId: null,
        ReasonId: null,
        PriorityId: 2,
        TotalPrice: null,
        TotalCost: null,
        SiteAddress1: "Testing Address",
        SiteAddress2: null,
        SiteAddress3: null,
        SiteCity: "Mequon",
        SiteRegion: "WI",
        SitePostalCode: "53092",
        ShipViaId: 1,
        RegionId: 1,
        DivisionId: null,
        Customer: {
            CustomerName: "Paveglio Leasing Leasing",
            CustomerNumber: "325",
            OpenOrderAmount: 0,
            Id: 651
        },
        AssignedTo: {
            FirstName: "Daniel",
            LastName: "Greuel",
            UserId: 40743,
            Id: 1821
        },
        Site: {
            SiteNumber: "Billing",
            Id: 600
        },
        RelatedCall: {
            Id: 40144
        },
        CustomerId: 651,
        AssignedToId: 40743,
        SiteId: 600,
        RelatedCallId: 40144,
        Id: 33531,
        OrderTypeId: null
    },
    {
        OrderNumber: "31166",
        OrderDate: toLocalDate("2018-12-13T00:00:00Z"),
        OrderStatusId: 12,
        TechOrderStatus: null,
        JobNumber: null,
        OrderedBy: null,
        WaitingForId: null,
        ReasonId: null,
        PriorityId: 2,
        TotalPrice: null,
        TotalCost: null,
        SiteAddress1: "3415 Saemann Ave2",
        SiteAddress2: "",
        SiteAddress3: "",
        SiteCity: "Sheboygan2",
        SiteRegion: "WI",
        SitePostalCode: "53081",
        ShipViaId: 8,
        RegionId: 1,
        DivisionId: null,
        Customer: {
            CustomerName: "Tri-State Paving",
            CustomerNumber: "000000000001",
            OpenOrderAmount: 35128708.55,
            Id: 1
        },
        AssignedTo: {
            FirstName: "Daniel",
            LastName: "Greuel",
            UserId: 40743,
            Id: 1821
        },
        Site: {
            SiteNumber: "Billing",
            Id: 19
        },
        RelatedCall: {
            Id: 40146
        },
        CustomerId: 1,
        AssignedToId: 40743,
        SiteId: 19,
        RelatedCallId: 40146,
        Id: 33532,
        OrderTypeId: null
    },
    {
        OrderNumber: "31167",
        OrderDate: toLocalDate("2018-12-13T00:00:00Z"),
        OrderStatusId: 12,
        TechOrderStatus: null,
        JobNumber: null,
        OrderedBy: null,
        WaitingForId: null,
        ReasonId: null,
        PriorityId: 2,
        TotalPrice: null,
        TotalCost: null,
        SiteAddress1: "Unknown",
        SiteAddress2: "",
        SiteAddress3: null,
        SiteCity: "Unknown",
        SiteRegion: "Unknown",
        SitePostalCode: "Unknown",
        ShipViaId: 1,
        RegionId: 1,
        DivisionId: null,
        Customer: {
            CustomerName: "Production Department",
            CustomerNumber: "000000012055",
            OpenOrderAmount: 0,
            Id: 18
        },
        AssignedTo: {
            FirstName: "Daniel",
            LastName: "Greuel",
            UserId: 40743,
            Id: 1821
        },
        Site: {
            SiteNumber: "Billing",
            Id: 49
        },
        RelatedCall: {
            Id: 40147
        },
        CustomerId: 18,
        AssignedToId: 40743,
        SiteId: 49,
        RelatedCallId: 40147,
        Id: 33533,
        OrderTypeId: null
    },
    {
        OrderNumber: "31168",
        OrderDate: toLocalDate("2018-12-13T00:00:00Z"),
        OrderStatusId: 12,
        TechOrderStatus: null,
        JobNumber: null,
        OrderedBy: null,
        WaitingForId: null,
        ReasonId: null,
        PriorityId: 2,
        TotalPrice: null,
        TotalCost: null,
        SiteAddress1: "910 Gateway Commons Circle",
        SiteAddress2: "",
        SiteAddress3: null,
        SiteCity: "Wake Forest",
        SiteRegion: "NC",
        SitePostalCode: "27587",
        ShipViaId: 1,
        RegionId: 1,
        DivisionId: null,
        Customer: {
            CustomerName: "C.B. Richard Ellis",
            CustomerNumber: "000000012011",
            OpenOrderAmount: 0,
            Id: 10
        },
        AssignedTo: {
            FirstName: "Daniel",
            LastName: "Greuel",
            UserId: 40743,
            Id: 1821
        },
        Site: {
            SiteNumber: "000000000000002",
            Id: 12
        },
        RelatedCall: {
            Id: 40149
        },
        CustomerId: 10,
        AssignedToId: 40743,
        SiteId: 12,
        RelatedCallId: 40149,
        Id: 33534,
        OrderTypeId: null
    },
    {
        OrderNumber: "31177",
        OrderDate: toLocalDate("2018-12-17T00:00:00Z"),
        OrderStatusId: 12,
        TechOrderStatus: null,
        JobNumber: null,
        OrderedBy: null,
        WaitingForId: null,
        ReasonId: null,
        PriorityId: null,
        TotalPrice: null,
        TotalCost: null,
        SiteAddress1: "413 Old Billerica Road",
        SiteAddress2: "",
        SiteAddress3: null,
        SiteCity: "Bedford",
        SiteRegion: "MA",
        SitePostalCode: "02114",
        ShipViaId: 1,
        RegionId: 1,
        DivisionId: null,
        Customer: {
            CustomerName: "GAP Incorporated",
            CustomerNumber: "000000012035",
            OpenOrderAmount: 1281.6,
            Id: 14
        },
        AssignedTo: {
            FirstName: "Daniel",
            LastName: "Greuel",
            UserId: 40743,
            Id: 1821
        },
        Site: {
            SiteNumber: "000000000000002",
            Id: 8
        },
        RelatedCall: {},
        CustomerId: 14,
        AssignedToId: 40743,
        SiteId: 8,
        RelatedCallId: null,
        Id: 33543,
        OrderTypeId: null
    }
];
exports.emptyComponent = (props) => React.createElement("div", null);
exports.testColumns = [
    {
        title: "OrderNumber",
        field: "OrderNumber",
        sortable: true,
        resizable: true,
        filter: "numeric",
        filterCell: exports.emptyComponent
    },
    {
        title: "OrderDate",
        field: "OrderDate",
        sortable: true,
        resizable: true,
        filter: "date",
        editor: "date",
        format: `{0:d}`,
        filterCell: exports.emptyComponent
    },
    {
        title: "CustomerName",
        field: "Customer.CustomerName",
        sortable: true,
        resizable: true,
        filterCell: exports.emptyComponent
    },
    {
        title: "TotalPrice",
        field: "TotalPrice",
        sortable: true,
        resizable: true,
        filter: "numeric",
        editor: "numeric",
        filterCell: exports.emptyComponent
    },
    {
        title: "AssignedTo",
        field: "AssignedTo",
        sortable: true,
        resizable: true,
        filter: "text",
        editor: "text",
        cell: ({ dataItem, className }) => {
            return (React.createElement("td", { className: className }, `${dataItem.AssignedTo.FirstName} ${dataItem.AssignedTo.LastName}`));
        }
    }
];
//# sourceMappingURL=testData.js.map